import { render, staticRenderFns } from "./WriteBugoJangView.vue?vue&type=template&id=89d6dd9e&scoped=true&"
import script from "./WriteBugoJangView.vue?vue&type=script&lang=js&"
export * from "./WriteBugoJangView.vue?vue&type=script&lang=js&"
import style0 from "./WriteBugoJangView.vue?vue&type=style&index=0&id=89d6dd9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d6dd9e",
  null
  
)

export default component.exports